import React from "react";
import plurales from "plurales";

import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

export default function Pag({
  current = 1,
  type,
  total,
  pageSize,
  next,
  previous,
  onPageChange,
}) {
  const pages = Math.ceil(total / pageSize);

  // Generate page numbers to display
  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 7;

    if (pages <= maxVisiblePages) {
      // Show all pages if total is small
      for (let i = 1; i <= pages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show first page, ellipsis, current range, ellipsis, last page
      const startPage = Math.max(1, current - 2);
      const endPage = Math.min(pages, current + 2);

      if (startPage > 1) {
        pageNumbers.push(1);
        if (startPage > 2) {
          pageNumbers.push("ellipsis-start");
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < pages) {
        if (endPage < pages - 1) {
          pageNumbers.push("ellipsis-end");
        }
        pageNumbers.push(pages);
      }
    }

    return pageNumbers;
  };

  return (
    <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 rounded-2xl py-3 sm:px-6">
      {/* Mobile view */}
      <div className="flex flex-1 justify-between sm:hidden">
        {previous && (
          <button
            onClick={() => onPageChange(current - 1)}
            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Previo
          </button>
        )}
        {next && (
          <button
            onClick={() => onPageChange(current + 1)}
            className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Siguiente
          </button>
        )}
      </div>

      {/* Desktop view */}
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            <span className="font-medium">{total}</span>
            &nbsp;{total === 1 ? type : plurales(type)}
          </p>
        </div>

        <Pagination>
          <PaginationContent>
            {previous && (
              <PaginationItem>
                <PaginationPrevious
                  onClick={() => onPageChange(current - 1)}
                  className="cursor-pointer"
                />
              </PaginationItem>
            )}

            {generatePageNumbers().map((pageNum, index) => (
              <PaginationItem key={index}>
                {pageNum === "ellipsis-start" || pageNum === "ellipsis-end" ? (
                  <PaginationEllipsis />
                ) : (
                  <PaginationLink
                    onClick={() => onPageChange(pageNum)}
                    isActive={pageNum === current}
                    className="cursor-pointer"
                  >
                    {pageNum}
                  </PaginationLink>
                )}
              </PaginationItem>
            ))}

            {next && (
              <PaginationItem>
                <PaginationNext
                  onClick={() => onPageChange(current + 1)}
                  className="cursor-pointer"
                />
              </PaginationItem>
            )}
          </PaginationContent>
        </Pagination>
      </div>
    </div>
  );
}

Pag.defaultProps = {
  onPageChange: () => true,
  total: null,
  pageSize: null,
  next: null,
  previous: null,
};
